import PropTypes from "prop-types";
const PropTypePrimaryButton = {
  callback: PropTypes.func,
  icon: PropTypes.shape({ svg: PropTypes.string }),
  colorScheme: PropTypes.string,
  width: PropTypes.string,
  isDisabled: PropTypes.bool,
  internalLink: PropTypes.any,
  transition: PropTypes.any,
  buttonText: PropTypes.string
};
export default PropTypePrimaryButton;
